import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import gameplayAiPlugin from '@internal/plugin-gameplayai';
import { navModule } from './modules/nav';
import { authenticationModule } from './modules/authentication';

export default createApp({
  features: [catalogPlugin, gameplayAiPlugin, authenticationModule, navModule],
});
